import {defineStore} from "pinia";

export const useStructureStore = defineStore('structureStore', {
    state: () => {
        return {
            structure: undefined,
            hydrated: false,
            segmentSelection: '',
            residueSelection: '',
            selectedSegment: undefined,
            selectedResidue: undefined
        }
    },
    actions: {
        fetchData(structureId) {
            fetch('/api/structure/' + structureId).then((response) => response.json()).then((data) => {
                this.structure = data;
                this.hydrated = true;
            })
        },
        addSegmentSelection(selection) {
            this.segmentSelection = selection;
        },
        addResidueSelection(selection) {
            this.residueSelection = selection;
        },
        selectSegment(segment) {
            this.selectedSegment = segment;
            this.addSegmentSelection(segment.selection);
        },
        selectResidue(chain, residue) {
            this.selectedResidue = residue;
            this.addResidueSelection(':' + chain + ' and ' + residue.position);
        },
    },
})
